import { connect } from 'react-redux'
import {
  formDecorator,
  getFormMeta,
  FormValueSelector
} from '../../../../../../Common/forms'
import { SPEC_SETTING_FORM_KEY } from '../../../../../../../constants/proposalTypes'
import SpecSettingModal from './SpecSettingModal'

const mapStateToProps = state => ({
  fields: getFormMeta(SPEC_SETTING_FORM_KEY)(state)
})
const ConnectedSpecSettingModal = connect(mapStateToProps)(SpecSettingModal)

const SpecSettingModalWithFormValue = props => (
  <FormValueSelector
    selector={
      select => ({
        productName: select('productName'),
        showExpiringAddon: select('showExpiringAddon'),
        specItems: select('specItems'),
        lengthUsedByFirstLayer: select('lengthUsedByFirstLayer'),
        level: select('level')
      })
    }
  >
    {
      formValues => (
        <ConnectedSpecSettingModal
          {...props}
          {...formValues}
        />
      )
    }

  </FormValueSelector>
)

const SPEC_SETTING_FORM_CONFIG = {
  form: SPEC_SETTING_FORM_KEY,
  destroyOnUnmount: true,
  keepDirtyOnReinitialize: false,
  forceUnregisterOnUnmount: true
}
const SpecSettingModalContainer = formDecorator(SPEC_SETTING_FORM_CONFIG)(SpecSettingModalWithFormValue)
export default SpecSettingModalContainer
